export default __webpack_public_path__ + "static/media/ryan-drawing.4b374df3.png";